import React, { SetStateAction } from 'react'
import Divider from '@material-ui/core/Divider'
import { Scrollbars } from 'react-custom-scrollbars'

import Swatch from '../Swatch'
import styles from './catalogue.module.scss'
import { Typography } from '@material-ui/core'
import * as THREE from 'three'
import Stage from '../../Stage'
import { SwatchLibrary } from 'designer/geoHandlers/Material/swatch'

interface swatch {
  name: string
  hex: any
  type: string
  id: number
}

interface Cat {
  name: string
  logo: string
  id: number
  swatches: swatch[]
  types: string[]
}

interface SelCat {
  name: string
  id: number
  logo: string
}

interface Sel {
  cat: SelCat
  swatch: swatch | undefined
}

interface Props {
  cat: Cat
  active: boolean
  onClickFn: React.Dispatch<SetStateAction<SelCat>>
  setSel: React.Dispatch<SetStateAction<Sel>>
}

const SLib = SwatchLibrary.instance
console.log(SLib.swatches)

const Catalogue = ({ cat, active, onClickFn, setSel }: Props) => {
  const [slSwatch, setSlSwatch] = React.useState<number>()
  const scrollRef = React.useRef<any>({})
  // const [selectedColor, setSelectedColor] = React.useState(new THREE.Color())
  const stage = Stage.getInstance()

  const changeMaterial = (color: any) => {
    // setSelectedColor(color)
    const selection = Stage.outlinePass.selectedObjects
    for (let section of selection) {
      section.traverse((s: any) => {
        if (s.type === 'Mesh') {
          s.material.color = new THREE.Color(color)
          s.material.needsUpdate = true
        }
      })
    }
    stage.update()
  }

  React.useEffect(() => {
    const mats: any = []
    const selection = Stage.outlinePass.selectedObjects
    for (let section of selection) {
      section.traverse((s: any) => {
        if (s.type === 'Mesh') {
          mats.push(s.material)
        }
      })
    }

    if (mats.length > 0) {
      // setSelectedColor(mats[0].color)
    }
  }, [])

  React.useEffect(() => {
    scrollRef.current.scrollToTop()
  }, [])

  return (
    <div
      className={styles.catalogueWarapper}
      onClick={() => onClickFn({ name: cat.name, id: cat.id, logo: cat.logo })}
    >
      <Divider className={styles.mRem} variant="fullWidth" />

      <div className={styles.curCatWrapper}>
        <div
          style={{
            backgroundImage: `url(${cat.logo})`,
          }}
          className={styles.curCatLogo}
        />
        <div className={styles.matTypesContainer}>
          {cat.types.map(typ => {
            const t = typ.split('::')
            return (
              <Typography
                variant="caption"
                key={t[0]}
                className={styles.matTypes}
              >
                {t[1]}&nbsp;&nbsp;{t[2]}
              </Typography>
            )
          })}
        </div>
      </div>

      {active && <Divider className={styles.mRem} variant="fullWidth" />}
      <Scrollbars
        style={{
          width: '380px',
          height: active ? '50vh' : '0vh',
          transition: 'height 600ms',
        }}
        ref={scrollRef}
      >
        <div className={styles.scrollbarDiv}>
          {SLib.swatches.map((swatch: any) => (
            <Swatch
              key={swatch.data.id}
              name={swatch.data.name}
              // type={swatch.type}
              // TODO: use swatch id
              active={slSwatch === swatch.id}
              hex={swatch.hex}
              onClickFn={() => {
                changeMaterial(swatch.hex)

                setSlSwatch(swatch.id)
                setSel({
                  cat: { name: cat.name, id: cat.id, logo: cat.logo },

                  swatch: {
                    name: swatch.name,
                    hex: swatch.hex,
                    type: swatch.type,
                    id: swatch.id,
                  },
                })
              }}
            />
          ))}
        </div>
      </Scrollbars>
      {/* <Divider className={styles.mRem} variant="fullWidth" />
      <div className={styles.catList}>
        {cat.map((c, i) => {
          return (
            <div
              key={c.id}
              className={styles.catLogo}
              style={{
                backgroundImage: `url(${c.logo})`,
              }}
              onClick={() => {
                setCurCat(i)
              }}
            />
          )
        })}
      </div> */}
    </div>
  )
}

export default Catalogue
